import { ACTION_TYPE_ROOT } from "../consts";

const makeAction = (actionType: string) => `${ACTION_TYPE_ROOT}${actionType}`;

const actionTypes = {
  RECEIVE_ASSIGNMENT: makeAction("RECEIVE_ASSIGNMENT"),
  RECEIVE_ASSIGNMENTS: makeAction("RECEIVE_ASSIGNMENTS"),
  DELETE_ASSIGNMENT: makeAction("DELETE_ASSIGNMENT"),
  DELETE_ASSIGNMENTS: makeAction("DELETE_ASSIGNMENTS"),
  FETCHED_ASSIGNMENT_QUESTION_MARKS: makeAction(
    "FETCHED_ASSIGNMENT_QUESTION_MARKS"
  ),
  UPDATE_ASSIGNMENT_QUESTION_MARKS: makeAction(
    "UPDATE_ASSIGNMENT_QUESTION_MARKS"
  ),
  UPDATE_ASSIGNMENT_EMBEDDED_QUESTION_MARK: makeAction(
    "UPDATE_ASSIGNMENT_EMBEDDED_QUESTION_MARK"
  ),
  UPDATE_ASSIGNMENT_QUESTIONS_AGGREGATES: makeAction(
    "UPDATE_ASSIGNMENT_QUESTIONS_AGGREGATES"
  )
};

export default actionTypes;
